import { clone } from 'lodash'

/**
 * raptor埋点
 * https://km.sankuai.com/page/1303945698
 */
const raptor = Mach.requireModule('Raptor')
// 默认Tag
const defaultTags = {
  uuid: Mach.env.uuid ?? '', // 用户设备ID
  osName: Mach.env.osName ?? '', // 系统名称
  osVersion: Mach.env.osVersion ?? '', // 系统版本
  deviceModel: Mach.env.deviceModel ?? '', // 机型
  appVersion: Mach.env.version ?? '', // APP版本号
  appName: Mach.env.appName ?? '', // APP名称
  bundleName: Mach.env.bundleName ?? '', // Bundle 名称（主包）
  bundleVersion: Mach.env.bundleName ?? '', // Bundle 版本（主包）
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
  env: Mach.env.isDebug ? 'Test' : 'Prod', // 环境
}
const objChangeString = (tags: Record<string, string | number>) => {
  const newTags = clone(tags)
  Object.keys(newTags).forEach(item => {
    newTags[item] = String(newTags[item])
  })
  return newTags
}
// 上报业务异常，会展示在 Raptor Web 端的异常分析页面
const reportBusinessException = async ({ type, message, tags }: { type: string; message?: string; tags?: Record<string, string | number> }) => {
  raptor?.reportBusinessException?.(
    type,
    message,
    objChangeString({
      ...tags,
      ...defaultTags,
    }),
  )
}
// 上报 Raptor 自定义指标，通常用于统计成功率
const reportMetrics = async ({ values, tags, sampleRate = 1 }: { values: Record<string, string | number | number[]>; tags: Record<string, string | number>; sampleRate?: number }) => {
  raptor?.reportMetrics?.(
    values,
    objChangeString({
      ...tags,
      ...defaultTags,
    }),
    sampleRate,
  )
}

const Raptor = {
  reportBusinessException,
  reportMetrics,
}

export default Raptor
